import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Loading from '../../components/loading';
import { LOGIN_URL, RETURN_URL, RESET_PWD_URL, REGIST_URL, LOGIN_FROM, PRIVACY_URL, LOGIN_AGREEMENT_URL } from '../../constants';
import store from 'store';

const PATTERN_EMAIL = /^\w+\.*\w+@(\w+[^\.]+\.){1,5}[a-zA-Z]{2,3}$/;
const PATTERN_PWD = /[a-zA-Z0-9]{6,20}/;

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            account: '',
            password: '',
            agree: true,
            error: {}
        };
        this.onTextChange = this.onTextChange.bind(this);
        this.onOptChange = this.onOptChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    componentWillMount() {
        const { from } = this.props.location.state || { from: { pathname: '/' } };
        store.set(LOGIN_FROM, from);
    }
    onOptChange(name, value) {
        this.setState({ [name]: value });
    }
    onTextChange(name, e) {
        const value = e.target.value ? e.target.value.trim() : '';
        this.setState({ [name]: value });
    }
    onSubmit(e) {
        e.preventDefault();
        const { account, password, agree } = this.state;
        const error = {};
        if (PATTERN_EMAIL.test(account) === false) {
            error.account = '帳號格式不正確';
        }
        if (PATTERN_PWD.test(password) === false) {
            error.password = '密碼格式不正確: 英數半形,長度至少6';
        }
        if (agree !== true) {
            error.agree = true;
        }
        if (Object.keys(error).length === 0) {
            this.refs.loginForm.submit();
        }
        this.setState({ error });
    }
    render() {
        const { error, account, password, agree } = this.state;
        const { loading, error: loginResult, isLogin } = this.props;
        if (isLogin) {
            return <Redirect to={store.get(LOGIN_FROM)} />;
        }
        return (
            <div className="container">
                <div className="page-header text-center">
                    <h1>酒吧登入</h1>
                </div>
                <div className="row">
                    <div className="col-md-6 col-md-offset-3">
                        <form ref="loginForm" onSubmit={this.onSubmit} method="post" action={`${LOGIN_URL}/login/pgproc.do`}>
                            <input name="returnUrl" type="hidden" value={RETURN_URL} />
                            <div className="form-group">
                                <label>酒吧帳號</label>
                                <input name="alias" type="email" className="form-control" placeholder="Email" value={account} onChange={e => this.onTextChange('account', e)} />
                                {error.account && <p className="text-danger">{error.account}</p>}
                            </div>
                            <div className="form-group">
                                <label>密碼</label>
                                <input name="password" type="password" className="form-control" placeholder="Password" value={password} onChange={e => this.onTextChange('password', e)} />
                                {error.password && <p className="text-danger">{error.password}</p>}
                            </div>
                            <div className={error.agree ? 'checkbox has-error' : 'checkbox'}>
                                <label>
                                    <input type="checkbox" checked={agree} onChange={() => this.onOptChange('agree', !agree)} /> 我已閱讀並同意 <a rel="noopener noreferrer" style={{ color: '#00a0e9' }} href={LOGIN_AGREEMENT_URL} target="_blank">服務條款</a> 及 <a style={{ color: '#00a0e9' }} rel="noopener noreferrer" href={PRIVACY_URL} target="_blank">隱私權政策</a>
                                </label>
                            </div>
                            {loading && <Loading />}
                            {loginResult && <p className="text-center text-danger">{loginResult}</p>}
                            <input type="submit" className="btn btn-pubgame btn-block" value="登入" />
                        </form>
                        <br />
                        <p className="text-center">
                            <a rel="noopener noreferrer" style={{ color: '#00a0e9' }} href={REGIST_URL} target="_blank">註冊會員</a> | <a style={{ color: '#00a0e9' }} rel="noopener noreferrer" href={RESET_PWD_URL} target="_blank">忘記密碼</a>
                        </p>
                    </div>
                </div>
                <div className="row">
                    <p className="text-center">或使用以下方式登入</p>
                    <div className="col-md-12">
                        <div className="text-center">
                            <a style={{ margin: '2px' }} href={`${LOGIN_URL}/login/fb/vip2017.do`} >
                                <img alt="facebook" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/icon_fb.png" width="35" height="35" />
                            </a>
                            <a style={{ margin: '2px' }} href={`${LOGIN_URL}/login/gp/vip2017.do`} >
                                <img alt="google" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/icon_g.png" width="35" height="35" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state.user
});

export default connect(
    mapStateToProps
)(Login)


// WEBPACK FOOTER //
// ./src/containers/login/login.jsx